// SCORM 2004 requires timeinterval to be formatted as:
// P[yY][mM][dD][T[hH][nM][s[.s]S]]
function ConvertMilliSecondsIntoSCORM2004Time(intTotalMilliseconds: number) {
  let ScormTime = '';

  let HundredthsOfASecond; // decrementing counter - work at the hundreths of a second level because that is the maximum precision required

  const HUNDREDTHS_PER_SECOND = 100;
  const HUNDREDTHS_PER_MINUTE = HUNDREDTHS_PER_SECOND * 60;
  const HUNDREDTHS_PER_HOUR = HUNDREDTHS_PER_MINUTE * 60;
  const HUNDREDTHS_PER_DAY = HUNDREDTHS_PER_HOUR * 24;
  const HUNDREDTHS_PER_MONTH = HUNDREDTHS_PER_DAY * ((365 * 4 + 1) / 48);
  const HUNDREDTHS_PER_YEAR = HUNDREDTHS_PER_MONTH * 12;

  intTotalMilliseconds = Math.abs(intTotalMilliseconds);
  HundredthsOfASecond = Math.floor(intTotalMilliseconds / 10);

  const Years = Math.floor(HundredthsOfASecond / HUNDREDTHS_PER_YEAR); // assumed to be 12 "average" months
  HundredthsOfASecond -= Years * HUNDREDTHS_PER_YEAR;

  // assumed to be an "average" month (figures a leap year every 4 years) = ((365*4) + 1) / 48 days - 30.4375 days per month
  const Months = Math.floor(HundredthsOfASecond / HUNDREDTHS_PER_MONTH);
  HundredthsOfASecond -= Months * HUNDREDTHS_PER_MONTH;

  const Days = Math.floor(HundredthsOfASecond / HUNDREDTHS_PER_DAY); // 24 hours
  HundredthsOfASecond -= Days * HUNDREDTHS_PER_DAY;

  const Hours = Math.floor(HundredthsOfASecond / HUNDREDTHS_PER_HOUR); // 60 minutes
  HundredthsOfASecond -= Hours * HUNDREDTHS_PER_HOUR;

  const Minutes = Math.floor(HundredthsOfASecond / HUNDREDTHS_PER_MINUTE); // 60 seconds
  HundredthsOfASecond -= Minutes * HUNDREDTHS_PER_MINUTE;

  const Seconds = Math.floor(HundredthsOfASecond / HUNDREDTHS_PER_SECOND); // 100 hundreths of a seconds
  HundredthsOfASecond -= Seconds * HUNDREDTHS_PER_SECOND;

  if (Years > 0) 
    ScormTime += Years + 'Y';
  
  if (Months > 0) 
    ScormTime += Months + 'M';
  
  if (Days > 0) 
    ScormTime += Days + 'D';
  

  //check to see if we have any time before adding the "T"
  if (HundredthsOfASecond + Seconds + Minutes + Hours > 0) {
    ScormTime += 'T';

    if (Hours > 0) 
      ScormTime += Hours + 'H';
    

    if (Minutes > 0) 
      ScormTime += Minutes + 'M';
    

    if (HundredthsOfASecond + Seconds > 0) {
      ScormTime += Seconds;

      if (HundredthsOfASecond > 0) 
        ScormTime += '.' + HundredthsOfASecond;
      

      ScormTime += 'S';
    }
  }

  if (ScormTime == '') 
    ScormTime = 'T0S';
  

  ScormTime = 'P' + ScormTime;

  return ScormTime;
}

const timeHandler = (function () {
  const startTime = new Date();
  return {
    getStartTime: startTime
  };
}());

export {timeHandler};

export default ConvertMilliSecondsIntoSCORM2004Time;
